import React, { FC } from 'react'
import { InfoBanner } from '@shared/ui/molecules'
import { useBindingsStore } from '../model/useBindingsStore'

const AnotherOperatorClientCard: FC = () => {
  const { isLoading } = useBindingsStore()

  if (isLoading) return null

  return <InfoBanner variant="orange">Для оплаты этим способом войдите по номеру МТС</InfoBanner>
}

export default AnotherOperatorClientCard
